import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Answering some common questions about React + D3 2018",
  "description": "",
  "published": "2018-08-02T00:00:00.000Z",
  "redirect_from": ["/blog/answering-common-questions-react-d3-2018/swizec/8546"],
  "categories": "d3, Front End, Learning, Personal, react, Side Projects, Technical, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I opened `}<a parentName="p" {...{
        "href": "https://gumroad.com/l/pMtnZ"
      }}>{`React + D3 2018 preorders`}</a>{` 7 days ago, and 50 people have already bought my updated book and course. So I guess this is happening 🤘`}</p>
    <p>{`Here's a few common questions you've been asking 👇`}</p>
    <h2 {...{
      "id": "is-react--d3-2018-a-physical-book"
    }}>{`Is React + D3 2018 a physical book?`}</h2>
    <p>{`Yes and no.`}</p>
    <p>{`It's definitely an ebook, and there's definitely going to be a few hours of video lessons that go with it. I've been practicing, and I know how to do video well now.`}</p>
    <p>{`As for physical, the previous editions didn't have a physical version. Out of ~700 people, 3 asked. But I think going back to paper is a growing trend, so `}<strong parentName="p">{`I'm looking into print-on-demand options`}</strong>{`. If I find something I like, there's going to be a physical edition.`}</p>
    <h2 {...{
      "id": "i-have-react--d3v4-do-i-get-a-free-update"
    }}>{`I have React + D3v4, do I get a free update?`}</h2>
    <p>{`That depends on which version of React + D3v4 you have.`}</p>
    <ul>
      <li parentName="ul">{`If you bought the $149 package, you get a free update with everything `}<em parentName="li">{`and you can participate in the workshops`}</em>{`.`}</li>
      <li parentName="ul">{`If you bought the $49 package, you get the updated book, but not the extra videos and exercises.`}</li>
      <li parentName="ul">{`If you got React+D3v4 as part of my 30-at-30 promotion, I love you, but you get just the bugfixes and not the new chapters.`}</li>
      <li parentName="ul">{`If you got it as part of the Patreon deal, you're great, but most of you churn after 2 or 3 months, so that model never really worked and needs to be rethought. No updates.`}</li>
    </ul>
    <p>{`You will get a specific email about the above with a link to claim your update over the next few days.`}</p>
    <p>{`tl;dr: `}<strong parentName="p">{`To join the live workshops in August, you have to preorder React + D3 2018 or have previously bought the `}{`\\`}{`\\`}{`\\`}{`$149+ package`}</strong></p>
    <h2 {...{
      "id": "i-have-an-even-older-edition-what-about-me"
    }}>{`I have an even older edition. What about me?`}</h2>
    <p>{`Sorry, React + D3v4 was a complete rewrite from earlier editions, and nobody got a free update. Therefore, you can't get a free update now, either.`}</p>
    <h2 {...{
      "id": "can-i-get-the-current-edition-while-i-wait-for-the-new-one"
    }}>{`Can I get the current edition while I wait for the new one?`}</h2>
    <p>{`Yes. I'm setting up those automations today and sending a manual email to everyone who already purchased.`}</p>
    <h2 {...{
      "id": "how-do-the-exclusive-preorder-workshops-work"
    }}>{`How do the exclusive preorder workshops work?`}</h2>
    <p>{`These are going to be 3 to 4 hour live online workshops. You'll join via Zoom or some other software (I'm open to suggestions), and we're going to build some stuff together.`}</p>
    <p>{`Aug 12, Aug 19, and Aug 26. Mark your calendar.`}</p>
    <p>{`The format will be similar to my all day in-person workshops 👇`}</p>
    <ul>
      <li parentName="ul">{`I'll explain some theory`}</li>
      <li parentName="ul">{`present a problem`}</li>
      <li parentName="ul">{`give you some time to think about/solve it`}</li>
      <li parentName="ul">{`then walk you through it`}</li>
    </ul>
    <p>{`Writing your own code is encouraged. That will help you learn. You'll get value just from listening too.`}</p>
    <p>{`If you miss a date, don't worry. You can come to either or all of them. Think of them as iterations.`}</p>
    <p>{`An edited version of these workshops will become the video course accompanying a $149 package of React + D3 2018. So not only do you get to participate live, help shape the content, and get answers to `}<em parentName="p">{`your specific questions`}</em>{`, preordering also gives you a $100 discount.`}</p>
    <p>{`Great deal 👌`}</p>
    <h2 {...{
      "id": "whats-new-anyway"
    }}>{`What's new anyway?`}</h2>
    <p>{`You're right. Nobody asked this question, but I wanted to reiterate so I can help you get excited and maybe `}<a parentName="p" {...{
        "href": "https://gumroad.com/l/pMtnZ"
      }}>{`click that preorder button`}</a>{` if you’re still on the fence ✌️`}</p>
    <ul>
      <li parentName="ul">{`⚛️ updated content for how react works in 2018 and 2019. That means React 16+, React Suspense, etc.`}</li>
      <li parentName="ul">{`📈 updated code for D3v5`}</li>
      <li parentName="ul">{`🚟 exploration of React Suspense implications`}</li>
      <li parentName="ul">{`🆕 chapter on ready-made dataviz components you can use`}</li>
      <li parentName="ul">{`🆕 new chapter on dataviz in React Native`}</li>
      <li parentName="ul">{`🆕 new chapter on dataviz in WebVR`}</li>
      <li parentName="ul">{`📦 move examples from Codepen to Codesandbox for better experience`}</li>
      <li parentName="ul">{`🏃 add more exercises and sample walkthroughs`}</li>
      <li parentName="ul">{`🎥 all new 2 to 3 hour video in full 4K`}</li>
    </ul>
    <p>{`I'm considering a WebAssembly chapter as well. See if that helps when you have humongous datasets.`}</p>
    {
      /*[if mso]>
       <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://gumroad.com/l/pMtnZ" style="height:40px;v-text-anchor:middle;width:200px;" arcsize="10%" strokecolor="#1e3650" fillcolor="#ffa824">
         <w:anchorlock/>
         <center style="color:#ffffff;font-family:sans-serif;font-size:13px;font-weight:bold;">Preorder now!</center>
       </v:roundrect>
      <![endif]*/
    }
    <p><a parentName="p" {...{
        "href": "https://gumroad.com/l/pMtnZ"
      }}>{`Preorder now!`}</a></p>
    <p>{`Cheers,`}</p>
    <p>{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      